export enum ViolationsSupportedActions {
  Exempt = 'exempt',
  Waive = 'waive',
  AddOwner = 'addOwner',
  RemoveOwner = 'removeOwner',
  SetAccess = 'setAccess',
  ListAccess = 'listAccess',
  Delete = 'delete',
  SendEmail = 'sendEmail',
  Quarantine = 'quarantine',
  Unquarantine = 'unquarantine',
  Start = 'start',
  Stop = 'stop',
  GetResourceDefinition = 'getResourceDefinition',
  SecureFlowSteps = 'secureFlowSteps',
  GetResourceSbomFile = 'getResourceSbomFile',
  GetRawResource = 'getRawResource',
  PowerplatformSetCopilotAuthentication = 'powerplatformSetCopilotAuthentication',
  PowerplatformGetRawFlowRuns = 'powerplatformGetRawFlowRuns',
  PowerplatformAgentDeleteAction = 'powerplatformAgentDeleteAction',
  PowerplatformAgentActionDeleteAction = 'powerplatformAgentActionDeleteAction',
  PowerplatformAgentActionSetStatusAction = 'powerplatformAgentActionSetStatusAction',
  PowerplatformAgentActionEnableAction = 'powerplatformAgentActionEnableAction',
  PowerplatformAgentActionDisableAction = 'powerplatformAgentActionDisableAction',
  PowerplatformAgentActionSetAuthenticationModeAction = 'powerplatformAgentActionSetAuthenticationModeAction',
  PowerplatformAgentActionSetConfirmationModeAction = 'powerplatformAgentActionSetConfirmationModeAction',
  PowerplatformAgentActionEnforceUserAuthenticationAction = 'powerplatformAgentActionEnforceUserAuthenticationAction',
  PowerplatformAgentActionEnforceUserConfirmationAction = 'powerplatformAgentActionEnforceUserConfirmationAction',
  PowerplatformAgentSetWebBrowsingAction = 'powerplatformAgentSetWebBrowsingAction',
  PowerplatformEnvironmentSetAuditAction = 'powerplatformEnvironmentSetAuditAction',
  ChatGptEnterpriseDeleteGptAction = 'chatGptEnterpriseDeleteGptAction',
  ChatGptEnterpriseIsolateGptAction = 'chatGptEnterpriseIsolateGptAction',
  ChatGptEnterpriseDeleteGptKnowledgeAction = 'chatGptEnterpriseDeleteGptKnowledgeAction',
  ChatGptEnterpriseGetGptKnowledgeFileUrlAction = 'chatGptEnterpriseGetGptKnowledgeFileUrlAction',
  ChatGptEnterpriseDeleteUserCanvasAction = 'chatGptEnterpriseDeleteUserCanvasAction',
  ChatGptEnterpriseGetUserCanvasAction = 'chatGptEnterpriseGetUserCanvasAction',
  RouteToSoc = 'routeToSoc',
}
